import React from "react";

// external imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import EmailIcon from "@mui/icons-material/Email";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { useLocation } from "react-router-dom";

const VerifyEmail = () => {
  const location = useLocation();
  const { email, text } = location.state || {};

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <EmailIcon style={{ fontSize: 60, marginBottom: 20 }} />
          <Typography variant="h5" gutterBottom>
            You're almost there!
          </Typography>
          <Typography gutterBottom>We sent an email to</Typography>
          <Typography gutterBottom>
            <strong>{email}</strong>
          </Typography>
          <Typography
            gutterBottom
            sx={{
              textAlign: "center",
            }}
          >
            {text}
          </Typography>
          <a href="/" style={{textAlign:"center",fontSize:"20px"}}>Go Back Home</a>
        </Box>
      </Container>
    </div>
  );
};

export default VerifyEmail;
